import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { BrowserUtils } from './browser-utils';
import { RestUtils } from './rest-utils';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(this.withXsrf(req)).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.updateXsrf(event.headers.get('X-XSRF-TOKEN'), event.url);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.updateXsrf(error.headers?.get('X-XSRF-TOKEN'), error.url);
        return throwError(() => error);
      })
    );
  }

  private withXsrf(req: HttpRequest<unknown>): HttpRequest<unknown> {
    let headers = req.headers.delete('X-XSRF-TOKEN');
    if (req.context.get(RestUtils.INSERT_XSRF) && this.requiresXsrf(req.method)) {
      const xsrf = BrowserUtils.getXsrfValue(req.url);
      if (xsrf) {
        headers = headers.set('X-XSRF-TOKEN', xsrf);
      }
    }

    return req.clone({ headers });
  }

  private updateXsrf(token: string | null, url: string | null): void {
    BrowserUtils.setXsrfValue(token, url);
  }

  private requiresXsrf(method: string): boolean {
    return !['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(method);
  }
}
